import { render, staticRenderFns } from "./EditProjectModal.vue?vue&type=template&id=4e5a5c60&scoped=true&"
import script from "./EditProjectModal.vue?vue&type=script&lang=js&"
export * from "./EditProjectModal.vue?vue&type=script&lang=js&"
import style0 from "./EditProjectModal.vue?vue&type=style&index=0&id=4e5a5c60&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5a5c60",
  null
  
)

export default component.exports